export const clx = (...classes: (string | undefined)[]) => {
  return classes.filter((c) => Boolean(c)).join(' ')
}
